import { render, staticRenderFns } from "./IcoEllipsisHorizontal.vue?vue&type=template&id=6a07b03a"
import script from "./IcoEllipsisHorizontal.vue?vue&type=script&lang=js"
export * from "./IcoEllipsisHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports